import { createSvgIcon } from "./Icon";

// SVGファイルをraw文字列としてインポート
import periodSettingSvgRaw from "./period-setting.svg?raw";
import statusCheckSvgRaw from "./status-check.svg?raw";
import storePlanSvgRaw from "./store-plan.svg?raw";
import aiCreateSvgRaw from "./ai-create.svg?raw";
import copySvgRaw from "./copy.svg?raw";
import pasteSvgRaw from "./paste.svg?raw";
import swapSvgRaw from "./swap.svg?raw";
import undoSvgRaw from "./undo.svg?raw";
import redoSvgRaw from "./redo.svg?raw";
import stampSvgRaw from "./stamp.svg?raw";
import clearSvgRaw from "./clear.svg?raw";
import checkSvgRaw from "./check.svg?raw";
import confirmSvgRaw from "./confirm.svg?raw";
import pdfExportSvgRaw from "./pdf-export.svg?raw";
import excelExportSvgRaw from "./excel-export.svg?raw";
import headerFilterSvgRaw from "./header-filter.svg?raw";
import sortSvgRaw from "./sort.svg?raw";
import conditionalFormatSvgRaw from "./conditional-format.svg?raw";

/** 15 申請期間設定 */
export const RibbonPeriodSettingIcon = createSvgIcon(periodSettingSvgRaw);
/** 16 申請状況確認 */
export const RibbonStatusCheckIcon = createSvgIcon(statusCheckSvgRaw);
/** 17 店舗計画 */
export const RibbonStorePlanIcon = createSvgIcon(storePlanSvgRaw);
/** 18 AI自動作成 */
export const RibbonAICreateIcon = createSvgIcon(aiCreateSvgRaw);
/** 19 コピー */
export const RibbonCopyIcon = createSvgIcon(copySvgRaw);
/** 20 ペースト */
export const RibbonPasteIcon = createSvgIcon(pasteSvgRaw);
/** 21 入れ替え */
export const RibbonSwapIcon = createSvgIcon(swapSvgRaw);
/** 22 Undo（元に戻す） */
export const RibbonUndoIcon = createSvgIcon(undoSvgRaw);
/** 23 Redo（やり直す） */
export const RibbonRedoIcon = createSvgIcon(redoSvgRaw);
/** 24 スタンプ */
export const RibbonStampIcon = createSvgIcon(stampSvgRaw);
/** 25 クリア */
export const RibbonClearIcon = createSvgIcon(clearSvgRaw);
/** 26 チェック */
export const RibbonCheckIcon = createSvgIcon(checkSvgRaw);
/** 27 確定 */
export const RibbonConfirmIcon = createSvgIcon(confirmSvgRaw);
/** 28 シフト表PDF出力 */
export const RibbonPdfExportIcon = createSvgIcon(pdfExportSvgRaw);
/** 29 シフト表Excel出力 */
export const RibbonExcelExportIcon = createSvgIcon(excelExportSvgRaw);
/** 30 ヘッダー絞り込み */
export const RibbonHeaderFilterIcon = createSvgIcon(headerFilterSvgRaw);
/** 31 並び替え */
export const RibbonSortIcon = createSvgIcon(sortSvgRaw);
/** 32 条件付き書式 */
export const RibbonConditionalFormatIcon = createSvgIcon(conditionalFormatSvgRaw);
